import { defineComponent as _defineComponent } from 'vue'
import RowField from "@/components/plant/RowField.vue"
import { PropType, ref } from "vue"
import { PlantDetail } from "@/models/plant/plant.detail"
import { usePlantStore } from "@/store/plant"
import { PlantForm } from "@/models/plant/plant.form"
import { useRouter } from "vue-router"
import ToggleableField from "@/components/plant/ToggleableField.vue"


const __default__ = {
  name: "PlantForm"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  plant: {
    type: Object as PropType<PlantForm>,
    required: true
  },
  id: String
},
  setup(__props, { expose }) {
  expose();

const props = __props



const edit = ref(!props.id)
const saving = ref(false)
const plantStore = usePlantStore()
const router = useRouter()

async function update() {
  try {
    saving.value = true
    await plantStore.update(props.id!!, props.plant)
    edit.value = false
  } finally {
    saving.value = false
  }
}

async function create() {
  try {
    saving.value = true
    const plant = await plantStore.create(props.plant)
    void router.replace({
      name: 'plant',
      params: {
        id: plant.id
      }
    })
    edit.value = false
  } finally {
    saving.value = false
  }
}

const __returned__ = { props, edit, saving, plantStore, router, update, create, RowField }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})